import { getTemplateData } from '../../../requests/login';
import { getItem, setItem } from '../../../utils/localStorage';

export const SetDefaultTemplateId =  (selectedHotel) => {
    if (selectedHotel) {
      // get user items
      const user = getItem('user');
      // get selected brand
      const selectedBrand = getItem('selectedBrand');
      const brandInfo = user.user.brands.find((o) => o.id === selectedBrand);

      if (brandInfo) {
        // get selected Hotel
        const selectedHotelInfo = brandInfo.hotels.find(
          (o) => o.id === selectedHotel
        );
        const defaultTemplateId = selectedHotelInfo.defaultTemplateId;
        setItem('defaultTemplateId', defaultTemplateId);

        if (defaultTemplateId) {
          getTemplateData(defaultTemplateId, user).then((res: any) => {
          });
        }
      }
    }
  };
